import { sendRequest } from '@/utils/request'

export const postReviewApi = (body: { productId: string; rating: number; comment: string; images: string[]; status: string }) =>
  sendRequest({ method: 'POST', url: '/review', body, cache: false })
